export default function PHP_strnatcmp() {
  return (
    <div>
      <h1>PHP_strnatcmp</h1>
    </div>
  );
}
